<script setup lang="ts">
import { onUnmounted } from 'vue';
import { GpBtn } from '@gportal/uikit';

const props = withDefaults(
  defineProps<{
    accept?: string;
    uploadInputId?: string;

    label?: string;
  }>(),
  {
    accept: '*/*',
    uploadInputId: 'upload-input',

    label: 'Select file',
  },
);

const emit = defineEmits<{
  (e: 'change', value: File): void;
}>();

const onFileSelect = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.files != null && target.files.length > 0) {
    emit('change', target.files[0]);
  }
};

const onOpenFileManager = () => {
  if (document.getElementById(props.uploadInputId) != null) {
    const inputElement = document.getElementById(props.uploadInputId) as HTMLInputElement;
    inputElement.click();

    return;
  }

  const inputElement = document.createElement('input');
  inputElement.setAttribute('type', 'file');
  inputElement.setAttribute('style', 'display:none');
  inputElement.setAttribute('id', props.uploadInputId);
  inputElement.setAttribute('accept', props.accept);

  inputElement.addEventListener('change', onFileSelect);

  document.body.appendChild(inputElement);

  inputElement.click();
};

const cleanupFileInput = () => {
  const inputElement = document.getElementById(props.uploadInputId);
  if (inputElement != null) {
    inputElement.removeEventListener('change', onFileSelect);
    document.body.removeChild(inputElement);
  }
};

defineExpose({
  cleanupFileInput,
});

onUnmounted(() => {
  cleanupFileInput();
});
</script>

<template>
  <GpBtn
    :icon="['fas', 'fa-folder-open']"
    btn-type="primary"
    outline
    size="sm"
    :label="label ?? 'Select file'"
    @click="onOpenFileManager"
  />
</template>

<style scoped></style>
